import { TenantInfo } from '../../types';

import { axios } from '@/lib/axios';

export const APIacceptInvitation = (token: string, forceAcceptOtherEmail?: boolean): Promise<TenantInfo> => {
    return axios.post(`/tenant/invitation/${token}/accept`, { forceAcceptOtherEmail });
};
